export const useChemicalResistanceGuideHelper = () => {
  const getHtml = (lang: string = 'en'): string => {
    if (lang === 'de') {
      return html('de')
    }
    return html('en')
  }

  return {
    getHtml
  }
}

const html = (lang: string): string => {
  return `
<div id="fstApp" class="wrapper">
<link rel="stylesheet" href="https://fst-resistanceguide.azurewebsites.net/css/style.css?v=1.03" />
<div vue="app" data-locale="${lang}">
    <crguide class="crguide fb-tool" v-cloak inline-template
        getmaterial-api="https://fst-resistanceguide.azurewebsites.net/api/Material/Get"
        getmedia-api="https://fst-resistanceguide.azurewebsites.net/api/Medium/Get"
        getreactions-api="https://fst-resistanceguide.azurewebsites.net/api/MaterialReactions/GetMaterialReactions"
        contactrequesturl="https://resistanceguide.fst.com/en/contact"
    >
        <div>
            <div class="fb-tool__selection">

                <div class="fb-tool__selection__selector fb-tool__selection__selector--media crguide__selection__selector--media">
                    <div class="fb-tool__selection__selector__header">
                        <h2>{{ $t("message.selectMedium") }}</h2>
                        <button class="btn btn--secondary cs-button cs-button--image" v-on:click.prevent="toggleMediaSelectionViewMobile">
                        </button>
                    </div>

                    <ul v-cloak class="fb-tool__selection__taglist cs-taglist block md:hidden" v-show="selectedMediaIds.length > 0">
                        <li v-for="medium in media" :key="medium.MediumId" v-if="medium.Selected === true">
                            <span class="tag" v-on:click="medium.Selected = false">
                                {{medium.MediumName}}&nbsp;&times;
                            </span>
                        </li>
                        <li class="cs-taglist__action" v-show="selectedMediaIds.length > 0"><a href="#" v-on:click.prevent="deselectMedia">{{ $t("message.clearAll") }}</a></li>
                    </ul>

                    <div class="fb-tool__modalcontainer" v-bind:class="{ 'fb-tool__modalcontainer--show' : showMediaSelectionMobile}">
                        <div class="fb-tool__selection__body">
                            <div class="fb-tool__selection__body__top">
                                <span>{{ $t("message.selectMedium") }}</span>
                                <div class="searchbox-wrapper">
                                    <div class="fb-tool__action__search search">
                                        <input type="text" v-bind:placeholder="$t('message.search') + '&hellip;'" v-model="mediumSearch">

                                    </div>
                                </div>
                            </div>

                            <ul class="fb-tool__selection__body__taglist cs-taglist">
                                <li v-for="medium in media" :key="medium.MediumId" v-if="medium.Selected === true">
                                    <span class="tag" v-on:click="medium.Selected = false">
                                        {{medium.MediumName}}&nbsp;&times;
                                    </span>
                                </li>
                                <li class="cs-taglist__action hidden md:block"><a href="#" v-on:click.prevent="deselectMedia">{{ $t("message.deselectAll") }}</a></li>
                            </ul>

                            <ul class="fb-tool__selection__body__list selectList">
                                <li v-for="filteredMedium in filteredMedia" :key="filteredMedium.MediumId" v-bind:class="{ 'selected' : filteredMedium.Selected}">
                                    <label>
                                        <input type="checkbox" v-model="filteredMedium.Selected">
                                        <span>{{filteredMedium.MediumName}}</span>
                                    </label>
                                </li>
                            </ul>
                            <div class="fb-tool__selection__body__action block md:hidden">
                                <button v-on:click.prevent="toggleMediaSelectionViewMobile">{{ $t("message.apply") }}</button>
                                <a href="#" v-on:click.prevent="deselectMedia" v-bind:class="{ 'disabled' : selectedMediaIds.length === 0}">{{ $t("message.deselectAll") }}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="fb-tool__selection__selector fb-tool__selection__selector--material crguide__selection__selector--material">
                    <div class="fb-tool__selection__selector__header">
                        <h2>{{ $t("message.selectMaterial") }}</h2>
                        <button class="btn btn--secondary cs-button cs-button--image" v-on:click.prevent="toggleMaterialSelectionViewMobile">
                        </button>
                    </div>

                    <ul v-cloak class="fb-tool__selection__taglist cs-taglist block md:hidden" v-show="selectedMaterialIds.length > 0">
                        <li v-for="material in materials" :key="material.MaterialId" v-if="material.Selected === true">
                            <span class="tag" v-on:click="material.Selected = false">
                                {{material.MaterialShortName}}&nbsp;&times;
                            </span>
                        </li>
                        <li class="cs-taglist__action" v-show="selectedMaterialIds.length > 0"><a href="#" v-on:click.prevent="deselectMaterial">{{ $t("message.deselectAll") }}</a></li>
                    </ul>

                    <div class="fb-tool__modalcontainer" v-bind:class="{ 'fb-tool__modalcontainer--show' : showMaterialSelectionMobile}">
                        <div class="fb-tool__selection__body">
                            <div class="fb-tool__selection__body__top">
                                <span>{{ $t("message.selectMaterial") }}</span>
                            </div>
                            <ul class="fb-tool__selection__body__taglist cs-taglist">
                                <li v-for="material in materials" :key="material.MaterialId" v-if="material.Selected === true">
                                    <span class="tag" v-on:click="material.Selected = false">
                                        {{material.MaterialShortName}}&nbsp;&times;
                                    </span>
                                </li>
                                <li class="cs-taglist__action hidden md:block"><a href="#" v-on:click.prevent="toggleSelectMaterials">{{ $t("message.selectOrDeselectAll") }}</a></li>
                            </ul>

                            <ul class="fb-tool__selection__body__list selectList">
                                <li v-for="material in materials" :key="material.MaterialId"  v-bind:class="{ 'selected' : material.Selected}">
                                    <label>
                                        <input type="checkbox" v-model="material.Selected">
                                        <span><b>{{material.MaterialShortName}}</b> {{material.MaterialName}}</span>
                                    </label>
                                </li>
                            </ul>
                            <div class="fb-tool__selection__body__action block md:hidden">
                                <button v-on:click.prevent="toggleMaterialSelectionViewMobile">{{ $t("message.apply") }}</button>
                                <a href="#" v-on:click.prevent="toggleSelectMaterials">{{ $t("message.selectOrDeselectAll") }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fb-tool__result">
                <h3>{{ $t("message.yourRequest") }}</h3>
                <div class="fb-tool__result__wrapper">
                    <table class="fb-tool__result__table">
                        <thead>

                            <tr>
                                <th class="column--fixed">{{ $t("message.medium") }}</th>
                                <th class="column--small">°C</th>
                                <th v-for="mfrId in materialsFromReactions" :key="mfrId">
                                    {{getMaterialById(mfrId).MaterialShortName}}
                                </th>
                            </tr>

                        </thead>

                        <tbody>

                            <tr v-for="react in reactions" :key="react.MaterialReactionId">
                                <td class="column--fixed" v-bind:data-mediumid="react.MediumId">{{getMediumById(react.MediumId).MediumName}}</td>
                                <td class="column--small">{{react.Temperature}}</td>
                                <td v-for="mr in react.MaterialReactions" :key="mr.MaterialId">
                                    <reaction-label
                                        v-bind:reaction-type="mr.Reaction"
                                        v-on:mouseenter.native="onReactionLabelMouseEnter(mr.Reaction, $event)"
                                        v-on:mouseleave.native="onReactionLabelMouseLeave($event)"
                                        ></reaction-label>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                </div>
                <div class="fb-tool__result__message" v-show="selectedReactionType !== 0">
                    <reaction-hint v-bind:reaction-type="selectedReactionType" v-on:close="closeReactionHint">
                        <div class="cs-alignRight cs-mt10">
                            <a class="btn btn--secondary cs-button cs-inlineBlock" href="#" v-on:click.prevent="sendContactRequest">{{ $t("message.contactUs") }}</a>
                        </div>
                    </reaction-hint>
                </div>
            </div>

            <tool-legend/>
        </div>
    </crguide>
</div>
</div>
`
}
